import axios from 'axios'

import { CurrenciesConvert1inch } from 'src/api/ActualCurrency1inch/types'
import { API_ENDPOINT } from 'src/api/ActualCurrency1inch/constants'

export const getActualCurrency1inch =
  async (): Promise<CurrenciesConvert1inch> => {
    const response = await axios.get<CurrenciesConvert1inch>(API_ENDPOINT)

    return response.data
  }
